const pathUrl = window.location.href.split("#")[0];
const length = pathUrl.split("/").length;
const lastPart = pathUrl.split("/")[length - 1];
const baseUrl = pathUrl.replace(lastPart, "");
const plat = process.env.VUE_APP_AXIOS_BASE_URL ? "" : "portal";
export const prefix = `${baseUrl}${plat}`;
export const logoImg = plat
  ? `${prefix}/rs/logo/get?type=6&orderBy=1`
  : `${baseUrl}rs/logo/get?type=6&orderBy=1`;
